//libraries
import React, { useEffect, useState } from 'react';
import { Row, Col, Container, Image, Form, } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import ObexRequestHandler from '../../handlers/ObexRequestsHandler';
// import SessionService from '../../services/SessionsService';
import { useHistory, useRouteMatch, useParams } from 'react-router-dom';


//components
import FooterMenuAccess from '../../components/functionalComponents/DashboardLayout/FooterMenu';

//assets
import { faStar, faSearch } from '@fortawesome/free-solid-svg-icons';
import logoMarketplace from '../../assets/img/logos/logo-marketplace-negativo.svg'
import logo_framework from '../../assets/img/AVAP_Marketplace.png';
import favicon from '../../assets/img/Favicon_AVAP_Marketplace.png'
import ReactGA from 'react-ga4';
import config from '../../configs/appConfig.json'

import NavbarMarket from '../../components/functionalComponents/baseLayout/navbar';


import icon_cloud from '../../assets/img/logos/icono_Cloud.svg'
import icon_dev from '../../assets/img/logos/icono_DS2.svg'
import icon_api from '../../assets/img/logos/icon_APIControVersion.svg'
import icon_publisher from '../../assets/img/logos/icono_publisher.svg'
import icon_linter from '../../assets/img/logos/icon_avap.svg'
import icon_verified from '../../assets/img/ui_icons/icono-verificado@2x.png'
import icon_descarga from '../../assets/img/ui_icons/icono-descarga.svg'


import { BrowserView, MobileView } from 'react-device-detect';
import mobileError from '../../assets/img/ilustraciones/ilustracion_retiro.svg'






//Dummy Data
const icons = {
    "icon_dev": icon_dev,
    "icon_api": icon_api,
    "icon_publisher": icon_publisher,
    "icon_linter": icon_linter,
};
//dummy Data Json
import appsData from './appsData.json'
import ObexRequestHandler from '../../handlers/ObexRequestsHandler';



const MarketplaceStore = () => {

    // const apps = appsData.apps || [];

    const [apps, setApps] = useState([]);
    const [apps_mr, setAppsMR] = useState([]);
    const [apps_mp, setAppsMP] = useState([]);

    //busqueda
    const [searchTerm, setSearchTerm] = useState(''); // Estado para el término de búsqueda
    const [typeFilter, setTypeFilter] = useState(''); // Estado para el tipo de filtro

    const filteredApps = apps.filter((app) =>
        (app.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
            app.devName.toLowerCase().includes(searchTerm.toLowerCase()) ||
            app.description.toLowerCase().includes(searchTerm.toLowerCase())) &&
        (typeFilter === '' || app.type.toLowerCase() === typeFilter.toLowerCase())
    );

    // Mostrar las apps filtradas por tipo aunque no haya búsqueda
    const appsToShow = searchTerm === '' && typeFilter === '' ? apps : filteredApps;


    const getApps = async () => {
        try {
            const result = (await ObexRequestHandler.get('/api_product_list')).data;
            setApps(result);
            const result2 = (await ObexRequestHandler.get('/api_product_list?most_rated=true')).data;
            setAppsMR(result2);
            const result3 = (await ObexRequestHandler.get('/api_product_list?most_installed=true')).data;
            setAppsMP(result3);

        } catch (error) {
            console.error('ERROR FETCHING APPS ', error);
        }
    }

    const history = useHistory();

    useEffect(() =>{

        if (/*config.url != 'https://avs-primary-pre.101obex.mooo.com' &&*/ true){
            ReactGA.initialize('G-5J60GTNR8T');
            ReactGA.send({ hitType: 'pageview', page: window.location.pathname, title: 'Avap Marketplace Main Page' });
            }
    
    }, [])

    useEffect(() => {
        //requests
        getApps();

        // favicon
        const link = document.createElement('link');
        link.rel = 'icon';
        link.href = favicon; // Usa la ruta importada directamente
        document.head.appendChild(link);

        // favicon
        return () => {
            document.head.removeChild(link);
        };
    }, []);


    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>

            <BrowserView>

                <div>

                    <NavbarMarket />
                    <div className="w-100 pt-50 bg-antiflash" >
                        <Container id='marketplaceStore' >
                            <Row id="mainheader" className='align-items-center justify-content-md-center'>
                                <Col lg="8">
                                    <div className="headerWrapper">
                                        <h1 className='headerTitle'>API Products</h1>
                                        <div className="mainSearch">
                                            <div className="searchWrapper">
                                                <input
                                                    name="search"
                                                    id="search"
                                                    placeholder='Search by Name'
                                                    type="text"
                                                    value={searchTerm}
                                                    onChange={(e) => setSearchTerm(e.target.value)

                                                    }
                                                />
                                                <button>
                                                    <FontAwesomeIcon icon={faSearch} size="1x" />
                                                </button>
                                            </div>
                                        </div>

                                    </div>
                                </Col>
                            </Row>


                            {/* Mostrar las cartas por defecto si no hay término de búsqueda */}
                            {searchTerm === '' && (
                                <>

                                    <Row id="featured" className='mt-5'>
                                        <Col lg="12" className='sectionTitle'>
                                            <div className="titleWrapper">
                                                <p>AVAP Technology</p>
                                                <a href="/marketplaceStore/all" className='marketLink'>See All</a>
                                            </div>
                                        </Col>

                                        {apps.map((item) => (
                                            <Col md="4" lg="2" sm="6" xs="6" className='px-custom  pb-3'>
                                                <a href={`/marketplaceStore/${item.api_product_id}/${item.version.replace(/\./g, '+')}`} className="storeCard">
                                                    <div className='icon'>
                                                        <Image src={atob(item.icon).toString()} />
                                                    </div>

                                                    <div className="infoWrapper">
                                                        <div className='title'>{item.name}</div>
                                                        <div className="developerName">{item.devName}  </div>
                                                        <div className='infoDw'>
                                                            <div className="version">
                                                                Version {item.version}
                                                            </div>
                                                            <div className="downloads">
                                                                <Image src={icon_descarga} /> {item.installations}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <hr className='mb-0 mt-3' />
                                                    <div className="bottom">

                                                        <div className="stars">
                                                            <div className="iconWrapper">
                                                                <Image src={icon_cloud} />
                                                            </div>
                                                            {Array.from({ length: 5 }, (v, i) => (
                                                                <FontAwesomeIcon
                                                                    key={i}
                                                                    icon={faStar}
                                                                    className={i < item.stars ? "c-brick" : "c-light-gray"}
                                                                    size="1x"
                                                                />
                                                            ))}
                                                        </div>
                                                        <div className="type">
                                                            {
                                                                item.type
                                                                    ? item.type // Si `item.type` no está vacío, muestra `item.type`.
                                                                    : (item.price > 0 ? `$${parseFloat(item.price).toFixed(2)}` : 'free') // Si `item.type` está vacío, muestra 'paid' o 'free' según el precio.
                                                            }
                                                        </div>
                                                    </div>

                                                </a>
                                            </Col>
                                        ))}


                                    </Row>
                                    <hr />
                                    <Row id="popular">
                                        <Col lg="12" className='sectionTitle'>
                                            <div className="titleWrapper">
                                                <p>Most Popular</p>
                                                <a href="/marketplaceStore/mostPopular" className='marketLink'>See All</a>
                                            </div>
                                        </Col>

                                        {apps_mp.map((item) => (
                                            <Col md="4" lg="2" sm="6" xs="6" className='px-custom  pb-3'>
                                                <a href={`/marketplaceStore/${item.api_product_id}/${item.version.replace(/\./g, '+')}`} className="storeCard">
                                                    <div className='icon'>
                                                        <Image src={atob(item.icon).toString()} />
                                                    </div>

                                                    <div className="infoWrapper">
                                                        <div className='title'>{item.name}</div>
                                                        <div className="developerName">{item.devName}  </div>
                                                        <div className='infoDw'>
                                                            <div className="version">
                                                                Version {item.version}
                                                            </div>
                                                            <div className="downloads">
                                                                <Image src={icon_descarga} /> {item.installations}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <hr className='mb-0 mt-3' />
                                                    <div className="bottom">

                                                        <div className="stars">
                                                            <div className="iconWrapper">
                                                                <Image src={icon_cloud} />
                                                            </div>
                                                            {Array.from({ length: 5 }, (v, i) => (
                                                                <FontAwesomeIcon
                                                                    key={i}
                                                                    icon={faStar}
                                                                    className={i < item.stars ? "c-brick" : "c-light-gray"}
                                                                    size="1x"
                                                                />
                                                            ))}
                                                        </div>
                                                        <div className="type">
                                                            {item.price > 0 ? '$'+parseFloat(item.price).toFixed(2) : 'free'}
                                                        </div>
                                                    </div>

                                                </a>
                                            </Col>
                                        ))}

                                    </Row>
                                    <hr />
                                    <Row id="rated" className='pb-5'>
                                        <Col lg="12" className='sectionTitle'>
                                            <div className="titleWrapper">
                                                <p>Best Rated</p>
                                                <a href="/marketplaceStore/bestRated" className='marketLink'>See All</a>
                                            </div>
                                        </Col>
                                        {apps_mr.map((item) => (
                                            <Col md="4" lg="2" sm="6" xs="6" className='px-custom  pb-3'>
                                                <a href={`/marketplaceStore/${item.api_product_id}/${item.version.replace(/\./g, '+')}`} className="storeCard">
                                                    <div className='icon'>
                                                        <Image src={atob(item.icon).toString()} />
                                                    </div>

                                                    <div className="infoWrapper">
                                                        <div className='title'>{item.name}</div>
                                                        <div className="developerName">{item.devName}  </div>
                                                        <div className='infoDw'>
                                                            <div className="version">
                                                                Version {item.version}
                                                            </div>
                                                            <div className="downloads">
                                                                <Image src={icon_descarga} /> {item.installations}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <hr className='mb-0 mt-3' />
                                                    <div className="bottom">

                                                        <div className="stars">
                                                            <div className="iconWrapper">
                                                                <Image src={icon_cloud} />
                                                            </div>
                                                            {Array.from({ length: 5 }, (v, i) => (
                                                                <FontAwesomeIcon
                                                                    key={i}
                                                                    icon={faStar}
                                                                    className={i < item.stars ? "c-brick" : "c-light-gray"}
                                                                    size="1x"
                                                                />
                                                            ))}
                                                        </div>
                                                        <div className="type">
                                                        {item.price > 0 ? '$'+parseFloat(item.price).toFixed(2) : 'free'}
                                                        </div>
                                                    </div>

                                                </a>
                                            </Col>
                                        ))}


                                    </Row>
                                </>
                            )}

                            {/* Mostrar los resultados de la búsqueda */}
                            {searchTerm !== '' && (
                                <Row className='pb-5 pt-6'>
                                    {filteredApps.length > 0 ? (
                                        filteredApps.map((item) => (
                                            <Col md="4" lg="2" sm="6" xs="6" className='px-custom  pb-3'>
                                                <a href={`/marketplaceStore/${item.api_product_id}/${item.version.replace(/\./g, '+')}`} className="storeCard">
                                                    <div className='icon'>
                                                        <Image src={atob(item.icon).toString()} />
                                                    </div>

                                                    <div className="infoWrapper">
                                                        <div className='title'>{item.name}</div>
                                                        <div className="developerName">{item.devName}  </div>
                                                        <div className='infoDw'>
                                                            <div className="version">
                                                                Version {item.version}
                                                            </div>
                                                            <div className="downloads">
                                                                <Image src={icon_descarga} /> {item.installations}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <hr className='mb-0 mt-3' />
                                                    <div className="bottom">

                                                        <div className="stars">
                                                            <div className="iconWrapper">
                                                                <Image src={icon_cloud} />
                                                            </div>
                                                            {Array.from({ length: 5 }, (v, i) => (
                                                                <FontAwesomeIcon
                                                                    key={i}
                                                                    icon={faStar}
                                                                    className={i < item.stars ? "c-brick" : "c-light-gray"}
                                                                    size="1x"
                                                                />
                                                            ))}
                                                        </div>
                                                        <div className="type">
                                                            {item.type}
                                                        </div>
                                                    </div>

                                                </a>
                                            </Col>
                                        ))
                                    ) : (
                                        <p>No results found</p>
                                    )}
                                </Row>
                            )}





                        </Container>
                    </div>
                    <FooterMenuAccess green={true} />



                </div>
            </BrowserView>

            <MobileView>
                <div className="w-100 bg-brick-light">
                    <div className="container">
                        <div className="roe">
                            <div className="col-12">
                                <p className='txt-30 c-brick text-center pt-5'>We're sorry!</p>
                                <img className='d-block m-auto pb-5' src={mobileError} alt="" />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container pt-5">
                    <div className="row">
                        <div className="col-12 px-4">
                            <img className='d-block m-auto pb-5' src={logo_framework} alt="" />
                            <p className='txt-20 txt-bold text-center'>This site is not designed for mobile devices.</p>
                            <p className='text-center'>Please visit us on a desktop browser to enjoy the full experience. <br />Thank you for understanding.</p>
                        </div>
                    </div>
                </div>
            </MobileView>
        </>


    )
}

export default MarketplaceStore;